/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pt_KampusInputs */

const en_cp_pt_kampus = /** @type {(inputs: Cp_Pt_KampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campus Partner (≥ 40 teams, MoU)`)
};

const id_cp_pt_kampus = /** @type {(inputs: Cp_Pt_KampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampus Mitra (≥ 40 tim, MoU)`)
};

/**
* | output |
* | --- |
* | "Campus Partner (≥ 40 teams, MoU)" |
*
* @param {Cp_Pt_KampusInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pt_kampus = /** @type {((inputs?: Cp_Pt_KampusInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pt_KampusInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pt_kampus(inputs)
	return en_cp_pt_kampus(inputs)
});